import { createFetchCollectionOptionsEpic, mlRel } from 'medialoopster/rest';

export default createFetchCollectionOptionsEpic(mlRel('collections'), {
  version: 3,
});
